<template>
    <div v-show="currentVisible" class="pp-popup__wrap"
        :class="['is-' + animate]">
        <div v-if="layer" class="pp-popup__layer" :style="{transform}"
            @click.prevent="clickLayer">
        </div>
        <div ref="popup" 
            :class="['pp-popup', customClass]" 
            :style="{width, height, transform}"
            @click.prevent>
            <div ref="header" class="pp-popup__title" :style="{textAlign: titleAlign}">
                <span v-if="showClose" class="pp-popup__close"
                    @click="hide">
                    <template v-if="closeText">{{closeText}}</template>
                    <i v-else class="pp-icon-close"></i>
                </span>
                <slot name="title">
                    {{title}}
                </slot>
            </div>
            <div ref="content" class="pp-popup__content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import * as PopupManagement from '../../../src/util/popupManagement.js'
/**
 * 弹窗
 * @desc 动画时间为.25s, 后期拓展参数before-close {Function}
 * @param {string} customClass pp-popup样式类
 * @param {string} animate 动画[right(default), left, top, bottom]
 * @param {boolean} visible 显示弹窗
 * @param {boolean} layer 遮罩层 default:true
 * @param {string} width 弹窗宽度
 * @param {string} height 弹窗高度
 * @param {string} title 标题内容
 * @param {string} titleAlign 标题对齐方式[left(default), right, center]
 * @param {boolean} showClose 显示关闭按钮 default:true
 * @param {string} closeText 关闭按钮文本
 * @param {boolean} clickLayerHide 点击遮罩层关闭弹窗 default: true
 * @param {boolean} appendToBody 将弹窗插入到body
 * 
 * @event show
 * @event showed
 * @event hid
 * @event hide
 */
export default {
    name: 'pp-popup',
    props: {
        customClass: String,
        animate: {
            type: String,
            default: 'right',
            validator: function(value) {
                return ['left', 'right', 'top', 'bottom'].includes(value);
            },
        },
        visible: Boolean,
        layer: {
            type: Boolean,
            default: true,
        },
        width: {
            type: String,
            default: '100%',
        },
        height: {
            type: String,
        },
        title: String,
        titleAlign: {
            type: String,
            default: 'left',
            validator: function(value) {
                return ['left', 'center', 'right'].includes(value);
            },
        },
        showClose: {
            type: Boolean,
            default: true,
        },
        closeText: String,
        clickLayerHide: {
            type: Boolean,
            default: true,
        },
        appendToBody: Boolean,
    },
    data: function() {
        return {
            contentVisible: false,
            currentVisible: false,
        };
    },
    computed: {
        transform: function() {
            let style = '';

            if(this.contentVisible) {
                style = this.translate3d()
            }
            else {
                switch(this.animate) {
                    default: ''
                        //no break
                    case 'right':
                        style = this.translate3d('100%')
                        break;
                    case 'left':
                        style = this.translate3d('-100%')
                        break;
                    case 'top':
                        style = this.translate3d(0, '-100%')
                        break;
                    case 'bottom':
                        style = this.translate3d(0, '100%')
                        break;
                }
            }
            return style;
        },
    },
    watch: {
        visible: function(n, o) {
            if(n) {
                this.$emit('show')
                this.currentVisible = true
                setTimeout(()=> {
                    this.$emit('showed')
                    this.contentVisible = true
                }, 250)
                this.$el.style.zIndex = PopupManagement.nextZIndex()
            }
            else {
                // this.$emit('hide')
                this.contentVisible = false
                setTimeout(()=> {
                    // this.$emit('hid')
                    this.currentVisible = false
                }, 250)
            }
        },
    },
    mounted: function() {
        this.contentVisible = this.currentVisible = this.visible
        this.$el.style.zIndex = PopupManagement.nextZIndex()
        if(this.appendToBody) {
            document.body.appendChild(this.$el)
        }
    },
    methods: {
        show: function() {
            this.$emit('update:visible', true);
            setTimeout(()=> {
                this.contentVisible = true
            }, 250)
        },

        hide: function() {
            this.contentVisible = false
            this.$emit('hide')
            setTimeout(()=> {
                this.$emit('update:visible', false)
                this.$emit('hid')
            }, 250)
        },

        translate3d: function(x = 0, y = 0, z = 0) {
            return `translate3d(${x}, ${y}, ${z})`;
        },

        clickLayer: function() {
            if(this.clickLayerHide) {
                this.hide()
            }
        },
    },
}
</script>
